import { gsap, Power3 } from "gsap";

import Win from './Window';
import { GetBy } from '../core/Element';

class Message extends Win {
  isShow = false;
  static AUTO_HIDE_DELAY = 3500;

  p;
  btn;
  _waiting;
  _autoHideTimer = null;

  constructor(__container) {
    super(__container, "message");
    this.directHide();

    this.p = GetBy.selector("p", this.container)[0];
    // this.btn = GetBy.selector("button", this.container)[0];
  }

  //====================================================================
  // AUTO HIDE CONTROL
  //====================================================================

  _startAutoHide() {
    this._clearAutoHide();

    this._autoHideTimer = setTimeout(() => {
      this.hide();
    }, Message.AUTO_HIDE_DELAY);
  }

  _clearAutoHide() {
    if (this._autoHideTimer) {
      clearTimeout(this._autoHideTimer);
      this._autoHideTimer = null;
    }
  }

  //====================================================================
  // API
  //====================================================================

  success(__text, __btn) {
    this.text(__text, "__success", __btn);
  }

  error(__text, __btn) {
    this.text(__text, "__error", __btn);
  }

  text(__text, __type, __btn) {
    if (this.isOpen) {
      this._waiting = {
        text: __text,
        btn: __btn,
        type: __type,
      }
    } else {
      this.p.textContent = __text;

      // if (__btn) {
      //   this.btn.textContent = __btn;
      // }

      if (__type) {
        this.container.classList.add(__type);
      }

      this.toggleState();
    }
  }

  //====================================================================
  // SHOW / HIDE
  //====================================================================

  show__effect(__d = 0) {
    this._clearAutoHide(); // por si acaso (re-show rápido)

    gsap.set(this.container, { y: this.container.offsetHeight, alpha: 1 });
    gsap.to(this.container, {
      y: 0,
      duration: .4,
      ease: Power3.easeOut,
      onComplete: () => { this.afterShow() }
    });
  }

  afterShow() {
    super.afterShow();
    this._startAutoHide(); // 👈 aquí empieza el countdown real

    this.isShow = true;
  }

  hide(__d = 0) {
    this._clearAutoHide(); // 👈 cancelar siempre al cerrar manualmente
    super.hide(__d);
  }

  hide__effect(__d = 0) {
    gsap.to(this.container, {
      y: this.container.offsetHeight,
      duration: .4,
      ease: Power3.easeOut,
      onComplete: () => { this.afterHide(); }
    });
  }

  afterHide() {
    this.container.classList.remove("__success");
    this.container.classList.remove("__error");

    super.afterHide();

    if (this._waiting) {
      this.text(this._waiting.text, this._waiting.type, this._waiting.btn);
      this._waiting = null;
    }

    if (this.isShow) {
      window.location.href = window.location.href;
      this.isShow = false;
    }
  }

  directHide() {
    this._clearAutoHide(); // importante también aquí
    gsap.set(this.container, { y: this.container.offsetHeight, alpha: 1 });
    super.directHide();
  }
}

export const WinMessage = new Message(GetBy.id("Message"));
